export default "__VITE_ASSET__8efcaf91__"